import { useMemo } from "react";
import { createSlice } from "@reduxjs/toolkit";

import { useInjectReducer } from "utils/@reduxjs/useInjectReducer";
import { useInjectSaga } from "utils/@reduxjs/useInjectSaga";

import { l1ImportFilesSaga } from "./saga";

export const initialState = {
  l1ImportFiles: {
    initialLoading: true,
    loading: false,
    error: null,
    files: [],
    total_files: 0,
    pagination: {}
  },

  l1ImportNewFile: {
    loading: false,
    error: null,
    success: false,
    url: null,
    size: null,
    name: null
  },

  deleteL1File: {
    loading: false,
    error: null,
    success: false
  },

  l1InsertFileRecord: {
    loading: false,
    error: null,
    success: false,
    data: null
  }
};

export const L1ImportFilesSlice = createSlice({
  name: "l1ImportFiles",
  initialState,
  reducers: {
    fetchL1ImportFiles: (state) => {
      state.l1ImportFiles.loading = true;
      state.l1ImportFiles.error = null;
    },
    fetchL1ImportFilesSuccess: (state, action) => {
      const { files, total_files, pagination } = action.payload;
      state.l1ImportFiles.loading = false;
      state.l1ImportFiles.initialLoading = false;
      state.l1ImportFiles.files = files;
      state.l1ImportFiles.total_files = total_files;
      state.l1ImportFiles.pagination = pagination;
    },
    fetchL1ImportFilesFailure: (state, action) => {
      state.l1ImportFiles.loading = false;
      state.l1ImportFiles.initialLoading = false;
      state.l1ImportFiles.error = action.payload;
    },
    resetUploadedFile: (state) => {
      state.l1ImportFiles.uploadedFile = {
        url: null,
        name: "",
        size: 0,
        loading: false
      };
    },

    uploadl1Files: (state, action) => {
      state.l1ImportNewFile.loading = true;
      state.l1ImportNewFile.error = null;
      state.l1ImportNewFile.success = false;
      state.l1ImportNewFile.url = null;
      state.l1ImportNewFile.size = null;
      state.l1ImportNewFile.name = null;
    },
    uploadl1FilesSuccess: (state, action) => {
      state.l1ImportNewFile.loading = false;
      state.l1ImportNewFile.success = true;
      state.l1ImportNewFile.url = action.payload.url;
      state.l1ImportNewFile.size = action.payload.size;
      state.l1ImportNewFile.name = action.payload.name;
    },
    uploadl1FilesFailure: (state, action) => {
      state.l1ImportNewFile.loading = false;
      state.l1ImportNewFile.error = action.payload;
      state.l1ImportNewFile.success = false;
    },

    resetUploadState: (state) => {
      state.l1ImportNewFile = {
        loading: false,
        error: null,
        success: false,
        url: null,
        size: null,
        name: null
      };
    },

    deleteL1FileRequest: (state) => {
      state.deleteL1File.loading = true;
      state.deleteL1File.error = null;
      state.deleteL1File.success = false;
    },

    deleteL1FileSuccess: (state) => {
      state.deleteL1File.loading = false;
      state.deleteL1File.success = true;

      // CLEAR UPLOADED FILE STATE
      state.l1ImportNewFile = {
        loading: false,
        error: null,
        success: false,
        url: null,
        size: null,
        name: null
      };
    },

    deleteL1FileFailure: (state, action) => {
      state.deleteL1File.loading = false;
      state.deleteL1File.error = action.payload;
      state.deleteL1File.success = false;
    },

    insertL1FileRecord: (state) => {
      state.l1InsertFileRecord.loading = true;
      state.l1InsertFileRecord.error = null;
      state.l1InsertFileRecord.success = false;
      state.l1InsertFileRecord.data = null;
    },
    insertL1FileRecordSuccess: (state, action) => {
      state.l1InsertFileRecord.loading = false;
      state.l1InsertFileRecord.success = true;
      state.l1InsertFileRecord.data = action.payload;

      state.l1ImportNewFile = {
        loading: false,
        error: null,
        success: false,
        url: null,
        size: null,
        name: null
      };
    },
    insertL1FileRecordFailure: (state, action) => {
      state.l1InsertFileRecord.loading = false;
      state.l1InsertFileRecord.error = action.payload;
      state.l1InsertFileRecord.success = false;
    }
  }
});

export const useL1ImportFilesSlice = () => {
  useInjectReducer(L1ImportFilesSlice.name, L1ImportFilesSlice.reducer);
  useInjectSaga(L1ImportFilesSlice.name, l1ImportFilesSaga);

  const actions = useMemo(() => L1ImportFilesSlice.actions, []);
  return { actions };
};

export const { actions: l1ImportFilesActions } = L1ImportFilesSlice;
export default L1ImportFilesSlice.reducer;
